// src/components/CompletedProjects.js
"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/CompletedProjects.css";
import "./../styles/Elecinstallation.css";

import Beams from "./Beams";
import completedImage from "../assets/completed.avif";

import '@fortawesome/fontawesome-free/css/all.min.css';


const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        {/* <h2 className="elec-design-hero-title">Completed Projects</h2> */}
        <p className="elec-design-hero-description">
          These projects highlight our commitment to quality, safety, and innovation, executed with precision and client satisfaction.
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content cn-1">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {item.paragraph.points.map((point, idx) => (
                  <p key={idx} className="elec-design-hero-step-point">
  <span className="elec-design-hero-arrow-icon-1">
<i class="fa-sharp fa-solid fa-circle-check"></i>
</span>
 {point}
</p>
                ))}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

const CompletedProjects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
   {
  title: "Year 2021-2025",

  paragraph: {
    points: [
       "Testing & Commissioning Works at 132/33KV SDMN SUBSTATION - ETIHAD WE SEIH DIBBA",
    "Testing & Commissioning Works at 33/11KV SEBU, JULFAR, IDHEN Substation - ETIHAD WE",
    "DEWA 33kV Switchgear Replacement Works at MUSHRIF 132/33kV Substation and 33kV Cable Diversion Works",
    "Testing & Commissioning Works at 132/11kV substation at Warsan Village – WRSNVLG (Balance Works)",
    "Installation, Testing & Commissioning works at 132/11kV TLALTNYA SS",
    "Installation, Testing & Commissioning Works at BIDA BIN SAUD, AL OYA 33/11KV Package Unit",
      "DEWA  CONTAINR 132/11kV and associated works",
      "Remote End modification works for final configuration of WRSNACMDN-WRSN feeder",
      "33/11kV GHSP, SS1 & SS2 Integration Works",
      "Annual Electrical Maintenance for GIS substation at MBR PHASE III 800 MW PV SOLAR PROJECT (PLOT A, B & C)",
      "Installation, Testing & Commissioning works at 132/11kV FORSAN SS",
      "Installation, Testing & Commissioning works at 132/11kV TUNISRD SS",
      "Annual Electrical Maintenance for GIS substation at MBR PHASE III 800 MW PV SOLAR PROJECT (PLOT A)",
      "Annual Electrical Maintenance for GIS substation at MBR PHASE III 800 MW PV SOLAR PROJECT (PLOT C)"
    ]
  }
},
   {
  title: "Year 2017-2020",
  paragraph: {
    points: [
      "Step & Touch Potential, Earth Grid Resistance Measurement Works at Rabwah and Qusais Industrial 132/11kV Substations",
      "Transformer Oil Filtration Works at 132/11kV Marina Community Substation",
      "11kV Cable Installation Works at 132/11kV Mushriff Park Substation",
      "HV GIS Interlocks & Alarm Testing Works at various substations under DEWA network",
      "AVR Relay Testing Works at 132/11kV Qusais Substation",
      "Dismantling, shifting, Installation, Testing of 10MVAR Shunt Reactor from SZRT SS to Tunisrd SS",
      "Transformer Oil filtration for cable box in Silicon 132/11kV Substation",
      "Soil Resistivity measurement at 132/11kV Substations (Marabea Road SS, Tlaltanya SS, Forsan SS)",
      "Installation, Testing & Commissioning works at 132/11kV WHEIDARD SS",
      "Installation, Testing & Commissioning works at 132/11kV EMRDVLAS SS",
      "Testing & Commissioning works at 220/33KV GRID STATION in Al TOWAYYA (AL AIN)",
      "Installation, Testing & Commissioning works at 132/11kV QUASIS SS",
      "Installation, Oil Filtration & associated works at 132/11kV GREEN HILLS SS",
      "Installation, Testing & Commissioning works at 132/11kV DUBAI HILLS SS",
      "Installation, Testing & Commissioning works at 132/11kV NATURE SS",
      "Installation, Testing & Commissioning works at 132/11kV MANKHOOL SS",
      "Testing & Commissioning of 18 Nos of 132 kV GIS bays (including auxiliary relays, backup relay, BCU test) and remote-end modification works at WASIT-C 132kV Substation",
      "Testing & Commissioning works at 132/11kV GARHOUD Substation",
      "Oil Filtration Works for Shunt Reactor at Shipment 132/11kV Substation",
      "Testing of 33kV / 375V, 2.7MVA transformer in MBR solar power plant",
      "Manpower Services at 132/11kV Aviation SS",
      "Installation of building earth mat and CRM in 400/132kV Canal Garden SS",
      "Installation of building earth mat and CRM in 132/11kV Liwan Substation",
      "PFC Recommissioning work at 132/11kV Doha Road Substation",
      "Manpower Services for Testing & Commissioning Engineer at 132/11kV Maaden SS",
      "GIS Bay extension works at DEWA M-Station",
      "Testing & Commissioning of SIC 132/33/11kV Substation",
      "Testing & Commissioning of 132/11kV MEDHMAR Substation",
      "Testing & Commissioning of 132/11kV VILLAM/s GE NAD AL HAMAR Substation",
      "Transformer Oil filtration for cable box in Shipment 132/11kV Substation",
      "Manpower Services for Transformer Testing Engineer at Second Warsan 132/11kV Substation",
      "Transformer Oil filtration at 132/11kV Muntazah Substation",
      "Transformer Oil filtration at 132/11kV JUMSOUTH Substation",
      "Earthing Transformer Oil filtration at 132/11kV Bahr Jumeirah Substation",
      "Testing & Commissioning of 132/11kV BAHR JUMEIRAH Substation",
      "Testing & Commissioning of 132/11kV Silicon Residence Substation",
      "Testing & Commissioning of 132/11kV JEBELALI HILS Substation",
      "Testing & Commissioning of 132/11kV DOWNTOWN Substation",
      "Manpower Services for consultant witness Engineer at 132/11kV Aviation Substation",
      "Manpower Services for consultant witness Engineer at 132/11kV Third Nad Al Shiba Substation",
      "Manpower Services for consultant witness Engineer at 132/11kV Operads, Financial Center & Khor Dubai Substations",
      "Manpower service for Testing Engineers at 132/11kV Muntazah SS",
      "Manpower service for Testing Engineers at 132/11kV Tijoori SS",
      "Manpower service for Testing Engineers for various projects 132/11kV Majan SS, 132/11kV VillaM/s GE Nad Al Hamar & OxyM/s GEn SS",
      "Manpower service for Testing Engineers for various projects 132/11kV Jumeirah VillaM/s GE SS, 132/11kV Horse race & M Station SS",
      "Manpower service for Testing Engineers at 132/11kV HUMANITARIAN CITY SS",
      "Manpower service for Testing Engineers at 132/11kV BUSINESS TOWER 132/11 KV Substation SS",
      "Manpower service for Testing Engineers for various projects 132/11kV Muhaisnah SS, 132/11kV Dubai Land residence, 132/11kV Mudondxb, 132/11kV Treatment Plant SS and 132/11kV Shipment SS",
      "Manpower service for Testing Engineers at 132/11kV SAFA FIRST SS"
    ]
  }
},
   {
  title: "Year 2013-2016",
  paragraph: {
    points: [
      "Testing & Commissioning of 132/11kV SHIBAHTS Substation",
      "Testing & Commissioning of 132/11kV MIRA Substation",
      "Installation, Testing & Commissioning works at 132/11kV POLICE HOUSING Substation",
      "Installation, Testing & Commissioning works at 132/11kV BURJKHALIFA Substation",
      "Manpower service for Testing Engineers at 400/132kV MBR Solar SS",
      "Manpower service for Testing Engineers at 132/11kV City walk SS",
      "Maintenance of various transformers and reactors at Al-Ghail and Al-Hamra Power Plant",
      "400kV Bay extension works in M-STATION",
      "Manpower service for Testing Engineers at 132/11kV DDP VillaM/s GE SS",
      "Manpower service for Testing Engineers at 132/11kV Theme Park SS",
      "Manpower services of Sr. Testing & Commissioning Engineer for various retrofitting jobs",
      "Manpower service for Testing Engineers at 132/11kV RESORT SS",
      "Manpower service for Testing Engineers at 132/11kV Business Bay Creek SS",
      "Manpower services of Sr. Testing & Commissioning Engineer for 132/11kV Cultural VillaM/s GE SS",
      "Testing & Commissioning of 132/11kV Wellness Villa",
      "Testing & Commissioning of 132/11kV Jazerajum Substation",
      "Testing & Commissioning of 132/11kV Khazan Substation",
      "Installation, Testing & Commissioning of 2 No's SVC Stations at Nahda & CarX 400/132kV SS and associated works",
      "Testing & Commissioning of 220/132/33/11kV ZAHEER SS - Project: N7733 at Al Ain",
      "Installation and Maintenance works of 33kV SwitchGear, 20MVA 33/11kV Transformer, SCADA and cabling works"
    ]
  }
}
  ];

  return (
    <>
        <div className="completed-container">
        {/* Beam background */}
        <div className="completed-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        {/* Left content section */}
        <div className="completed-left" data-aos="fade-right">
          <h1>Completed Projects</h1>
          <p>
            Acume realises that each project we undertake is unique in terms of our clients' management values.
            Our framework is key to providing services that enrich their existing systems and processes at their facility.
            Our approach is to build strong business partnerships with our clientele that emphasize our prime interest:
            <strong> "Client Focused Customization"</strong>.
          </p>
        </div>

        {/* Right image section */}
        <div className="completed-right" data-aos="fade-left">
          <img src={completedImage} alt="Completed Projects" className="completed-image" />
        </div>
      </div>

      <ElecDesignHeroSection data={timelineData} />
    </>
  );
};

export default CompletedProjects;
